 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"8":"stencil-ion-avatar_3-ios-entry-js","9":"stencil-ion-avatar_3-md-entry-js","10":"stencil-ion-back-button-ios-entry-js","11":"stencil-ion-back-button-md-entry-js","12":"stencil-ion-backdrop-ios-entry-js","13":"stencil-ion-backdrop-md-entry-js","14":"stencil-ion-card_5-ios-entry-js","15":"stencil-ion-card_5-md-entry-js","16":"stencil-ion-checkbox-ios-entry-js","17":"stencil-ion-checkbox-md-entry-js","18":"stencil-ion-chip-ios-entry-js","19":"stencil-ion-chip-md-entry-js","20":"stencil-ion-col_3-entry-js","21":"stencil-ion-fab_3-ios-entry-js","22":"stencil-ion-fab_3-md-entry-js","23":"stencil-ion-img-entry-js","24":"stencil-ion-infinite-scroll_2-ios-entry-js","25":"stencil-ion-infinite-scroll_2-md-entry-js","26":"stencil-ion-input-ios-entry-js","27":"stencil-ion-input-md-entry-js","28":"stencil-ion-loading-ios-entry-js","29":"stencil-ion-loading-md-entry-js","30":"stencil-ion-popover-ios-entry-js","31":"stencil-ion-popover-md-entry-js","32":"stencil-ion-progress-bar-ios-entry-js","33":"stencil-ion-progress-bar-md-entry-js","34":"stencil-ion-radio_2-ios-entry-js","35":"stencil-ion-radio_2-md-entry-js","36":"stencil-ion-reorder_2-ios-entry-js","37":"stencil-ion-reorder_2-md-entry-js","38":"stencil-ion-ripple-effect-entry-js","39":"stencil-ion-spinner-entry-js","40":"stencil-ion-split-pane-ios-entry-js","41":"stencil-ion-split-pane-md-entry-js","42":"stencil-ion-tab-bar_2-ios-entry-js","43":"stencil-ion-tab-bar_2-md-entry-js","44":"stencil-ion-tab_2-entry-js","45":"stencil-ion-text-entry-js","46":"stencil-ion-textarea-ios-entry-js","47":"stencil-ion-textarea-md-entry-js","48":"stencil-ion-toggle-ios-entry-js","49":"stencil-ion-toggle-md-entry-js","50":"stencil-ion-virtual-scroll-entry-js"}[chunkId]||chunkId) + "." + {"0":"ba61f000","1":"5d9d8e35","2":"24aa241e","3":"040a9364","4":"71bc7a04","5":"b939e7bd","8":"3a3e002d","9":"0989faf5","10":"1a6647da","11":"56e08887","12":"c33ab775","13":"efd900e4","14":"b4a2bdc0","15":"1df57b63","16":"c1f67f00","17":"a595645c","18":"9b5affc3","19":"904bb97c","20":"e70236fd","21":"2d7bb8c9","22":"4509e527","23":"76b9b133","24":"d88d646d","25":"33e4d04e","26":"ae32b214","27":"da33aa20","28":"2d3d06f6","29":"9056f3b9","30":"4b181ebb","31":"33781cbb","32":"33c4fb98","33":"75030466","34":"61974131","35":"773d6245","36":"2c350771","37":"82795155","38":"0871c956","39":"fcf5bc22","40":"3adc673c","41":"df2f4137","42":"ee7348ec","43":"d813b424","44":"6a6d3a09","45":"2e5fe38c","46":"5bd4326f","47":"83ae3729","48":"9a62fe4b","49":"c0e103d9","50":"1f34dd94","52":"616d57e7","53":"c6bc8c68","54":"964dfe97","55":"3ded28f4","56":"f362e579","57":"848de592","58":"966c2d55","59":"1bd91d18","60":"3d8e9e05","61":"a3ea3b95","62":"23a98cc7","63":"ff63e445","64":"45308d00","65":"1b8c0296","66":"7a07ec5b","67":"69e4133b","68":"3faa1f85","69":"65b34e67","70":"8707996f","71":"791beeb4","72":"7117efb4","73":"da6a7abb","74":"194a1a26","75":"f45944de","76":"20b80e90","77":"86933bd4","78":"a3d3b00d","79":"8a33850b","80":"a6eda94f","81":"1cfe8765","82":"10a76949","83":"916a1112","84":"20835238","85":"fcdf7cd9","86":"dea5495a","87":"643b69fa","88":"8ec42e71","89":"9302e9d8","90":"9d9c9fd5","91":"493753ee"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpcgmobile"] = this["webpackJsonpcgmobile"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
